import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskAssignedToUser } from 'api/notifications/meta';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { Causer } from './causer';

export const TaskAssignedToUserView: FC<{
  meta: TaskAssignedToUser;
  isTaskWithFormInstance: boolean;
}> = ({ meta: { by, externalUser }, isTaskWithFormInstance }) => {
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  return (
    <FormattedMessage
      id={
        isTaskWithFormInstance
          ? 'notifications.messages.form_task_assigned'
          : 'notifications.messages.task_assigned'
      }
      values={{
        causer: <Causer user={userDetails} />,
      }}
    />
  );
};
